module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.creative) ? [_c('box-widget', {
    staticClass: "builder",
    attrs: {
      "icon": "pencil"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.header')) + " (" + _vm._s(_vm.$t('fn.complex.format', {
    format: _vm.creative.type
  })) + ")"), _c('b-btn', {
    staticClass: "float-right save-btn ml-1",
    attrs: {
      "theme": "default-filter",
      "loading": _vm.savingType === 2,
      "disabled": _vm.saving || _vm.moving,
      "data-builder-button": "save"
    },
    on: {
      "click": function($event) {
        _vm.checkAndSave(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.save')))]), (_vm.canFinishCreative) ? _c('b-btn', {
    staticClass: "float-right save-btn ml-1",
    attrs: {
      "theme": "default-filter",
      "variant": "danger",
      "loading": _vm.savingType === 1,
      "disabled": _vm.saving,
      "data-builder-button": "finish"
    },
    on: {
      "click": function($event) {
        _vm.checkAndSave(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.save-finish')))]) : _vm._e(), (_vm.permissions.includes("canMoveFromHold")) ? _c('b-btn', {
    staticClass: "float-right save-btn ml-1",
    attrs: {
      "theme": "default-filter",
      "variant": "danger",
      "loading": _vm.moving,
      "disabled": _vm.moving
    },
    on: {
      "click": _vm.onMoveForward
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.move-from-hold')))]) : _vm._e()], 1), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 left-content"
  }, [(_vm.configuration.message) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.message'))), _c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.getFieldInfo('message')),
      expression: "getFieldInfo('message')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-textarea', {
    staticClass: "creative-input",
    attrs: {
      "rows": 6,
      "maxlength": _vm.configuration.message,
      "placeholder": _vm.defaultCreativeValues.message,
      "data-builder-item": "message"
    },
    model: {
      value: (_vm.creative.message),
      callback: function($$v) {
        _vm.$set(_vm.creative, "message", $$v)
      },
      expression: "creative.message"
    }
  })], 1)] : _vm._e(), (_vm.configuration.name) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.name'))), _c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.getFieldInfo('name')),
      expression: "getFieldInfo('name')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "maxlength": _vm.configuration.name,
      "placeholder": _vm.defaultCreativeValues.name,
      "data-builder-item": "name"
    },
    model: {
      value: (_vm.creative.name),
      callback: function($$v) {
        _vm.$set(_vm.creative, "name", $$v)
      },
      expression: "creative.name"
    }
  })], 1)] : _vm._e(), (_vm.configuration.offer_title) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.offer_title'))), _c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.getFieldInfo('offer_title', 'offer_config.title')),
      expression: "getFieldInfo('offer_title', 'offer_config.title')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "maxlength": _vm.configuration.offer_title,
      "placeholder": _vm.defaultCreativeValues.offer_config.title,
      "data-builder-item": "offer_title"
    },
    model: {
      value: (_vm.creative.offer_config.title),
      callback: function($$v) {
        _vm.$set(_vm.creative.offer_config, "title", $$v)
      },
      expression: "creative.offer_config.title"
    }
  })], 1)] : _vm._e(), (_vm.configuration.description) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.description'))), _c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.getFieldInfo('description')),
      expression: "getFieldInfo('description')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "maxlength": _vm.configuration.description,
      "placeholder": _vm.defaultCreativeValues.description,
      "data-builder-item": "description"
    },
    model: {
      value: (_vm.creative.description),
      callback: function($$v) {
        _vm.$set(_vm.creative, "description", $$v)
      },
      expression: "creative.description"
    }
  })], 1)] : _vm._e(), (_vm.configuration.offer_details) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.offer_details'))), _c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.getFieldInfo('offer_details', 'offer_config.details')),
      expression: "getFieldInfo('offer_details', 'offer_config.details')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "maxlength": _vm.configuration.offer_details,
      "placeholder": _vm.defaultCreativeValues.offer_config.details,
      "data-builder-item": "offer_details"
    },
    model: {
      value: (_vm.creative.offer_config.details),
      callback: function($$v) {
        _vm.$set(_vm.creative.offer_config, "details", $$v)
      },
      expression: "creative.offer_config.details"
    }
  })], 1)] : _vm._e(), (_vm.configuration.caption) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.caption'))), _c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.getFieldInfo('caption')),
      expression: "getFieldInfo('caption')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "maxlength": _vm.configuration.caption,
      "placeholder": _vm.defaultCreativeValues.caption,
      "data-builder-item": "caption"
    },
    model: {
      value: (_vm.creative.caption),
      callback: function($$v) {
        _vm.$set(_vm.creative, "caption", $$v)
      },
      expression: "creative.caption"
    }
  })], 1)] : _vm._e(), (_vm.configuration.transition_ms) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.transition'))), _c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.getFieldInfo('transition')),
      expression: "getFieldInfo('transition')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "type": "number",
      "min": _vm.configuration.transition_ms,
      "data-builder-item": "transition_ms"
    },
    on: {
      "change": function($event) {
        _vm.onMsChange("transition_ms", $event)
      }
    },
    model: {
      value: (_vm.creative.transition_ms),
      callback: function($$v) {
        _vm.$set(_vm.creative, "transition_ms", $$v)
      },
      expression: "creative.transition_ms"
    }
  })], 1)] : _vm._e(), (_vm.configuration.duration_ms) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.duration'))), _c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.getFieldInfo('duration')),
      expression: "getFieldInfo('duration')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "type": "number",
      "min": _vm.configuration.duration_ms,
      "data-builder-item": "duration"
    },
    on: {
      "change": function($event) {
        _vm.onMsChange("duration_ms", $event)
      }
    },
    model: {
      value: (_vm.creative.duration_ms),
      callback: function($$v) {
        _vm.$set(_vm.creative, "duration_ms", $$v)
      },
      expression: "creative.duration_ms"
    }
  })], 1)] : _vm._e(), (_vm.configuration.end_date_time) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.end_date_time')))]), _c('div', {
    staticClass: "box-widget-list-value",
    attrs: {
      "data-builder-item": "offer_end_date"
    }
  }, [_c('datetimepicker', {
    attrs: {
      "disabled": {
        to: _vm.creative.offer_config.date_range_start,
        from: _vm.creative.offer_config.date_range_end
      },
      "id": String((_vm._uid + "_end_date"))
    },
    model: {
      value: (_vm.creative.offer_config.end_date_time),
      callback: function($$v) {
        _vm.$set(_vm.creative.offer_config, "end_date_time", $$v)
      },
      expression: "creative.offer_config.end_date_time"
    }
  })], 1)] : _vm._e(), (_vm.configuration.code_type) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.code_type'))), (_vm.settings.isOfferTypeOne) ? [_c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.getFieldInfo('offer_code', 'offer_config.code')),
      expression: "getFieldInfo('offer_code', 'offer_config.code')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })] : _vm._e()], 2), _c('div', {
    staticClass: "box-widget-list-value",
    class: {
      'row': _vm.settings.isOfferTypeOne, 'd-flex': _vm.settings.isOfferTypeOne
    }
  }, [_c('div', {
    class: {
      'col-md-4': _vm.settings.isOfferTypeOne
    }
  }, [_c('b-form-select', {
    staticClass: "creative-input",
    attrs: {
      "options": _vm._f("translateOptions")(_vm.configuration.code_type, "pos.campaign.creatives.adv-builder.code_type_options", _vm.$t),
      "data-builder-item": "offer_code_type"
    },
    model: {
      value: (_vm.creative.offer_config.code_type),
      callback: function($$v) {
        _vm.$set(_vm.creative.offer_config, "code_type", $$v)
      },
      expression: "creative.offer_config.code_type"
    }
  })], 1), _c('div', {
    class: {
      'col-md-8': _vm.settings.isOfferTypeOne, 'd-none': !_vm.settings.isOfferTypeOne
    }
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "maxlength": _vm.configuration.offer_code,
      "placeholder": _vm.defaultCreativeValues.offer_config.code,
      "data-builder-item": "offer_code"
    },
    model: {
      value: (_vm.creative.offer_config.code),
      callback: function($$v) {
        _vm.$set(_vm.creative.offer_config, "code", $$v)
      },
      expression: "creative.offer_config.code"
    }
  })], 1)])] : _vm._e(), (_vm.configuration.redeem) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.redeem')))]), _c('div', {
    staticClass: "box-widget-list-value",
    class: {
      'row': _vm.settings.isRedeemUrl, 'd-flex': _vm.settings.isRedeemUrl
    }
  }, [_c('div', {
    class: {
      'col-md-6': _vm.settings.isRedeemUrl
    }
  }, [_c('b-form-select', {
    staticClass: "creative-input",
    attrs: {
      "options": _vm._f("translateOptions")(_vm.configuration.redeem, "pos.campaign.creatives.adv-builder.redeem_options", _vm.$t),
      "data-builder-item": "offer_redeem"
    },
    model: {
      value: (_vm.creative.offer_config.redeem),
      callback: function($$v) {
        _vm.$set(_vm.creative.offer_config, "redeem", $$v)
      },
      expression: "creative.offer_config.redeem"
    }
  })], 1), _c('div', {
    class: {
      'col-md-6': _vm.settings.isRedeemUrl, 'd-none': !_vm.settings.isRedeemUrl
    }
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "data-builder-item": "offer_url"
    },
    model: {
      value: (_vm.creative.offer_config.offer_url),
      callback: function($$v) {
        _vm.$set(_vm.creative.offer_config, "offer_url", $$v)
      },
      expression: "creative.offer_config.offer_url"
    }
  })], 1)])] : _vm._e(), (_vm.configuration.t_c) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.t_c'))), _c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.getFieldInfo('t_c', 'offer_config.t_c')),
      expression: "getFieldInfo('t_c', 'offer_config.t_c')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-textarea', {
    staticClass: "creative-input",
    attrs: {
      "rows": 8,
      "maxlength": _vm.configuration.t_c,
      "placeholder": _vm.defaultCreativeValues.offer_config.t_c,
      "data-builder-item": "offer_t_c"
    },
    model: {
      value: (_vm.creative.offer_config.t_c),
      callback: function($$v) {
        _vm.$set(_vm.creative.offer_config, "t_c", $$v)
      },
      expression: "creative.offer_config.t_c"
    }
  })], 1)] : _vm._e(), _c('div', {
    staticClass: "row"
  }, [(_vm.configuration.call_to_action) ? _c('div', {
    staticClass: "col-md-9"
  }, [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.call-to-action')))]), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-select', {
    staticClass: "creative-input",
    attrs: {
      "options": _vm.ctaOptions,
      "data-builder-item": "cta"
    },
    model: {
      value: (_vm.creative.cta),
      callback: function($$v) {
        _vm.$set(_vm.creative, "cta", $$v)
      },
      expression: "creative.cta"
    }
  })], 1), (_vm.creative.cta == "GET_DIRECTIONS") ? _c('div', [_c('markdown', {
    staticClass: "box-widget-list-value",
    attrs: {
      "source": _vm.$t('pos.campaign.creatives.adv-builder.info.get-directions-warning')
    }
  })], 1) : _vm._e()]) : _vm._e(), (_vm.canAddFiles) ? _c('div', {
    staticClass: "col-md-3 text-right"
  }, [_c('b-button', {
    staticClass: "add-card-btn",
    attrs: {
      "variant": "danger",
      "data-builder-button": "add_file`"
    },
    on: {
      "click": _vm.addCard
    }
  }, [_c('icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1) : _vm._e()]), (_vm.creative.cta == "CALL_NOW") ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.phone-number'))), _c('div', {
    staticClass: "box-widget-list-value"
  })]), _c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "placeholder": _vm.$t('pos.campaign.creatives.adv-builder.placeholders.phone-number')
    },
    model: {
      value: (_vm.creative.cta_phone),
      callback: function($$v) {
        _vm.$set(_vm.creative, "cta_phone", $$v)
      },
      expression: "creative.cta_phone"
    }
  })], 1)]) : _vm._e(), _c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.files'))), _c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.getFieldInfo('files')),
      expression: "getFieldInfo('files')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1), _c('draggable', {
    ref: "draggable",
    staticClass: "file-list",
    attrs: {
      "element": "ul",
      "options": _vm.dragOptions,
      "data-builder-files-min": _vm.configuration.media_count_min,
      "data-builder-files-max": _vm.configuration.media_count_max
    },
    model: {
      value: (_vm.creative.media),
      callback: function($$v) {
        _vm.$set(_vm.creative, "media", $$v)
      },
      expression: "creative.media"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": 'flip-list'
    }
  }, _vm._l((_vm.creative.media), function(file, key) {
    return _c('li', {
      key: file.unique
    }, [_c('b-card', {
      staticClass: "carousel-card",
      class: {
        "slideshow-file": _vm.isSlideshow, "carousel-file": _vm.isCarousel
      }
    }, [(_vm.creative.media.length > 1) ? _c('div', {
      staticClass: "handle-container"
    }, [_c('div', {
      staticClass: "handle"
    }, [_c('icon', {
      attrs: {
        "name": "bars"
      }
    })], 1)]) : _vm._e(), _c('div', {
      staticClass: "row"
    }, [(_vm.canRemoveFiles) ? _c('b-button', {
      staticClass: "remove-btn",
      attrs: {
        "variant": "danger",
        "data-builder-button": String(("files_" + key + "_remove_file"))
      },
      on: {
        "click": function($event) {
          _vm.removeMediaFile(file.unique)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "trash"
      }
    })], 1) : _vm._e(), _c('div', {
      class: {
        "col-md-5": _vm.isCarousel, "col-12": !_vm.isCarousel
      }
    }, [_c('file-upload', {
      staticClass: "text-center",
      attrs: {
        "files": file.file && file.file.id > 0 ? [file.file] : [],
        "data-builder-item": String(("files_" + key + "_fileupload")),
        "single": "single",
        "acceptedFiles": _vm.configuration.media_formats.map(function (format) { return ("." + format); }).join(",")
      },
      on: {
        "update:files": function($event) {
          _vm.updateMediaFile(file.unique, $event)
        }
      }
    })], 1), (_vm.isCarousel) ? _c('div', {
      staticClass: "col-md-7 carousel-card-right"
    }, [(_vm.configuration.media_field_name) ? [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.name'))), _c('span', {
      directives: [{
        name: "b-popover",
        rawName: "v-b-popover.hover",
        value: (_vm.getFieldInfo('media_field_name', _vm.creative.media[key].name)),
        expression: "getFieldInfo('media_field_name', creative.media[key].name)",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "hint-block"
    }), _c('icon', {
      attrs: {
        "name": "question-circle"
      }
    })], 1), _c('div', {
      staticClass: "box-widget-list-value"
    }, [_c('b-form-input', {
      staticClass: "creative-input",
      attrs: {
        "placeholder": _vm.defaultCreativeValues.media.name,
        "maxlength": _vm.configuration.media_field_name,
        "data-builder-item": String(("files_" + key + "_name"))
      },
      model: {
        value: (_vm.creative.media[key].name),
        callback: function($$v) {
          _vm.$set(_vm.creative.media[key], "name", $$v)
        },
        expression: "creative.media[key].name"
      }
    })], 1)] : _vm._e(), (_vm.configuration.media_field_description) ? [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.description'))), _c('span', {
      directives: [{
        name: "b-popover",
        rawName: "v-b-popover.hover",
        value: (_vm.getFieldInfo('media_field_description', _vm.creative.media[key].description)),
        expression: "getFieldInfo('media_field_description', creative.media[key].description)",
        modifiers: {
          "hover": true
        }
      }],
      staticClass: "hint-block"
    }), _c('icon', {
      attrs: {
        "name": "question-circle"
      }
    })], 1), _c('div', {
      staticClass: "box-widget-list-value"
    }, [_c('b-form-input', {
      staticClass: "creative-input",
      attrs: {
        "placeholder": _vm.defaultCreativeValues.media.description,
        "maxlength": _vm.configuration.media_field_description,
        "data-builder-item": String(("files_" + key + "_description"))
      },
      model: {
        value: (_vm.creative.media[key].description),
        callback: function($$v) {
          _vm.$set(_vm.creative.media[key], "description", $$v)
        },
        expression: "creative.media[key].description"
      }
    })], 1)] : _vm._e(), (_vm.configuration.media_field_link) ? [_c('h2', {
      staticClass: "box-widget-list-header"
    }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.destination-url')))]), _c('div', {
      staticClass: "box-widget-list-value"
    }, [_c('b-form-input', {
      staticClass: "creative-input",
      attrs: {
        "placeholder": _vm.$t('pos.campaign.creatives.adv-builder.link'),
        "data-builder-item": String(("files_" + key + "_link"))
      },
      model: {
        value: (_vm.creative.media[key].link),
        callback: function($$v) {
          _vm.$set(_vm.creative.media[key], "link", $$v)
        },
        expression: "creative.media[key].link"
      }
    })], 1)] : _vm._e()], 2) : _vm._e()], 1)])], 1)
  }))], 1), _c('hr'), (_vm.configuration.privacy_policy_link) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.privacy-policy-link')))]), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "maxlength": _vm.configuration.privacy_policy_link,
      "placeholder": _vm.$t("pos.creative.lead_config.privacy_policy_link"),
      "data-builder-item": "lead_privacy_policy_link"
    },
    model: {
      value: (_vm.creative.lead_config.privacy_policy_link),
      callback: function($$v) {
        _vm.$set(_vm.creative.lead_config, "privacy_policy_link", $$v)
      },
      expression: "creative.lead_config.privacy_policy_link"
    }
  })], 1)] : _vm._e(), (_vm.leadQuestionVisible) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.default-question')))]), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-input', {
    staticClass: "creative-input",
    attrs: {
      "maxlength": _vm.configuration.default_question,
      "placeholder": _vm.$t("pos.creative.lead_config.default_question"),
      "data-builder-item": "lead_question"
    },
    model: {
      value: (_vm.creative.lead_config.default_question),
      callback: function($$v) {
        _vm.$set(_vm.creative.lead_config, "default_question", $$v)
      },
      expression: "creative.lead_config.default_question"
    }
  })], 1)] : _vm._e(), (_vm.configuration.lead_media_formats) ? [_c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.adv-builder.lead-photo')))]), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('file-upload', {
    staticClass: "text-center",
    attrs: {
      "files": _vm.creative.lead_photo && _vm.creative.lead_photo.id > 0 ? [_vm.creative.lead_photo] : [],
      "data-builder-item": "lead_photo_fileupload",
      "single": "single",
      "acceptedFiles": _vm.configuration.lead_media_formats.map(function (format) { return ("." + format); }).join(",")
    },
    on: {
      "update:files": _vm.updateLeadPhoto
    }
  })], 1)] : _vm._e()], 2), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "campaign-post-head"
  }, [_c('div', {
    staticClass: "campaign-post-last-save"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.last-save')))]), _c('div', {
    staticClass: "campaign-post-date"
  }, [_vm._v(_vm._s(_vm.createdAt))]), _c('div', {
    staticClass: "campaign-post-id"
  }, [_vm._v("ID " + _vm._s(_vm.creative.id))]), _c('div', {
    staticClass: "clearfix"
  })]), _c('creative-preview', {
    attrs: {
      "creative": _vm.creative,
      "facebookPage": _vm.creative.campaign.fbpage,
      "landingPage": _vm.landingPage,
      "placeholders": "placeholders",
      "enableFormPreview": true
    }
  })], 1)]), (_vm.permissions.includes("moveBack") && _vm.wipStatus) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 left-content pt-5"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.reject-title')))]), _c('h2', {
    staticClass: "box-widget-list-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.reject-comment'))), _c('span', {
    directives: [{
      name: "b-popover",
      rawName: "v-b-popover.hover",
      value: (_vm.$t('pos.creative.rejection-info')),
      expression: "$t('pos.creative.rejection-info')",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "hint-block"
  }), _c('icon', {
    attrs: {
      "name": "question-circle"
    }
  })], 1), _c('div', {
    staticClass: "box-widget-list-value"
  }, [_c('b-form-textarea', {
    staticClass: "creative-input",
    attrs: {
      "rows": 5,
      "placeholder": _vm.$t('pos.creative.rejection-placeholder')
    },
    model: {
      value: (_vm.reject_reason),
      callback: function($$v) {
        _vm.reject_reason = $$v
      },
      expression: "reject_reason"
    }
  })], 1), _c('div', {
    staticClass: "save-btn-container pb-3"
  }, [_c('gotu-nav-button', {
    staticClass: "reject-btn",
    attrs: {
      "theme": "default-filter",
      "disabled": _vm.moving
    },
    on: {
      "click": function($event) {
        _vm.reject()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.creative.reject')))])], 1)])]) : _vm._e()])], 2)] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67d8f9a8"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/adv-builder/AdvBuilder.vue
// module id = 2058
// module chunks = 1